import { defineComponent } from 'vue';
import axios from 'axios';
export default defineComponent({
  name: 'Microsite Override Main',
  data() {
    return {
      banner: {},
      articles: [],
      videoModal: false
    };
  },
  created() {
    this.getArticles();
    this.getBanner();
  },
  computed: {
    isLoggedIn() {
      return window.nexon.sso.isLoggedIn;
    }
  },
  methods: {
    async getBanner() {
      const {
        data
      } = await axios.get(`${process.env.VUE_APP_MS_CMS_PATH}/banners/micro-site/override`);
      if (data && data[0]) this.banner = data && data[0];
      return this.banner;
    },
    async getArticles() {
      const {
        data
      } = await axios.get(`${process.env.VUE_APP_MS_CMS_PATH}/news/micro-site/override`);
      if (data) this.articles = data;
      return this.articles;
    },
    openModal() {
      this.videoModal = true;
      if (window.innerWidth && document.body && document.body.clientWidth && window.innerWidth !== document.body.clientWidth) {
        document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
      }
      document.body.classList.add('show-modal');
    },
    closeModal() {
      this.videoModal = false;
      document.body.classList.remove('show-modal');
      document.body.style.paddingRight = '';
    }
  }
});